/**
 * Created by emhaje-workspace on 5/18/17.
 */
import {Alert, Modal} from 'react-bootstrap'
import ModalHeader from 'components/Modal/ModalHeader'
import {connect} from 'react-redux'
import {Field, FieldArray, reduxForm, getFormValues, change} from 'redux-form'
import {
  onCancelModalAddItem,
  setModalDataForm,
  getItemsFromAPI,
  onChangeNamespace
} from 'actions/inventory/purchaseOrder/purchaseOrder'
import styles from './ModalAddItem.css'
import {rupiah} from 'utils/formatter'
import WarningMessage from 'components/WarningMessage/WarningMessage'
import SettingField from 'components/Fields/ReduxForm/SettingField'
import {NAMESPACE_INGREDIENTS} from 'actions/inventory/constants'
import ItemHasRecipe from 'components/ItemHasRecipe'
import {askConfirmAction} from 'actions/confirm-action'
import SearchModal from 'components/Fields/ReduxForm/SearchModal'

const validate = (values) => {
  const errors = {}
  const itemsErrors = []
  if (values.items) {
    values.items.forEach((member, index) => {
      let unitCostString = member.unitcost + ''
      let orderString = member.order + ''
      const memberErrors = {}
      if (member.order && orderString.match(/^0\d/)) {
        memberErrors.order = 'Please enter a valid Number'
        itemsErrors[index] = memberErrors
      }
      if (parseInt(member.order) > 999999) {
        memberErrors.order = 'Order must be less than 999999'
        itemsErrors[index] = memberErrors
      }
      if (member.unitcost && unitCostString.match(/^0\d/)) {
        memberErrors.unitcost = 'Please enter a valid Number'
        itemsErrors[index] = memberErrors
      }
      if (parseInt(member.unitcost) > 99999999999) {
        memberErrors.unitcost = 'Unit cost must be less than 99.999.999.999'
        itemsErrors[index] = memberErrors
      }
    })
  }
  if (itemsErrors.length) {
    errors.items = itemsErrors
  }
  return errors
}

const normalizeNumber = (value = 0, previousValue) => {
  if (value === '') {
    return value
  } else {
    if (!isNaN(value)) {
      return value
    } else {
      return previousValue
    }
  }
}

const nameField = (props) => {
  const {input} = props
  return <input {...input} defaultValue={input.value} readOnly className={`${styles.itemDetail} form-control`} />
}

const stockField = (props) => {
  const {input} = props
  return <input {...input} placeholder={input.value} readOnly className={`${styles.itemStock} form-control`} />
}

const totalField = (props) => {
  const {input} = props
  return <input {...input} readOnly placeholder='Order' className={`${styles.itemDetail} form-control`} />
}

class ModalAddItem extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      openErrorAlert: false,
      selectValue: null,
      errorItemName: null,
      itemHasRecipe: false
    }
  }

  componentDidMount () {
    const {dispatch, POForm, search: {namespace}} = this.props
    dispatch(getItemsFromAPI({
      outlet_id: POForm.outlet,
      page: 1,
      per_page: 100,
      no_categories: true,
      keyword: '',
      namespace: namespace,
      first: true
    }))
  }

  render () {
    let {showModalItem, isLoading, items, temporaryItem, alreadyAddedItem, handleSubmit, search: {namespace}} = this.props
    let options = []
    if (items.results) {
      options = items.results.map((item) => {
        return {value: item.id, label: item.name}
      })
    }
    return (
      <Modal show={showModalItem} className={`${styles.modalitem}`}>
        <ModalHeader title={namespace === NAMESPACE_INGREDIENTS ? 'Add Ingredients' : 'Add Items'} />
        <form onSubmit={this.props.handleSubmit}>
          <Modal.Body className={styles.modalBody}>
            {this.state.openErrorAlert && <div className={styles['warning-style']}><Alert bsStyle='danger' >
              <span onClick={this._dismissError} className={`glyphicon glyphicon-remove ${styles['dismiss-warning-button']}`} aria-hidden='true' />
              <h5 className={`ml-30px`}>Maximum {this.state.errorItemName} in stock 999999</h5>
            </Alert>
            </div>}
            <Field
              component={SearchModal}
              type='text'
              name='search-item'
              placeholder={namespace === NAMESPACE_INGREDIENTS ? 'Search ingredients' : 'Search items'}
              options={options}
              onClickItem={this._onSelectedItem}
              onInputChange={this._onKeywordChange}
              inputValue={this.state.selectValue}
              onMenuScrollToBottom={this._onSearchReachBottom}
              isHasMore={this._hasMore}
              isLoading={isLoading}
            />
            <ItemHasRecipe hasRecipe={this.state.itemHasRecipe} onClickIngredient={this._clickIngredient} />
            {temporaryItem && (namespace !== NAMESPACE_INGREDIENTS) && !this.state.itemHasRecipe && <Field
              component={this._headerField}
              name='header'
              isOneItem={temporaryItem.item_variants.length === 1 && temporaryItem.item_variants[0].name === ''}
            />}
            {temporaryItem && (namespace === NAMESPACE_INGREDIENTS) && !this.state.itemHasRecipe && <Field
              component={this._headerField}
              name='header'
              isOneItem={false}
            />}
            {alreadyAddedItem && !this.state.itemHasRecipe && <div className={styles['warning-message-wrapper']}>
              <WarningMessage>
                &nbsp;&nbsp;&nbsp;This {namespace === NAMESPACE_INGREDIENTS ? 'ingredients' : 'items'} already added, go to <a href='javascript:void(0)' onClick={this._onHide}><u><i>Purchase order table</i></u></a> to edit
              </WarningMessage>
            </div>}
            <div className='row'>
              {temporaryItem && !this.state.itemHasRecipe && <FieldArray
                component={this._fieldItem}
                name='items'
            />}
            </div>
          </Modal.Body>
          <Modal.Footer>
            <span className='pull-left'>
              <button className='btn btn-default' onClick={this._onHide}>
                Cancel
              </button>
            </span>
            <span className='pull-right'>
              <button
                className={(!temporaryItem || this.state.itemHasRecipe ? `btn ${styles['disableBtnAddItem']}` : 'btn btn-primary')}
                disabled={!temporaryItem || this.state.itemHasRecipe}
                onClick={handleSubmit(this._onClickSave)}>
                Add
              </button>
            </span>
          </Modal.Footer>
        </form>
      </Modal>
    )
  }
  _hasMore = () => {
    const {items: {currentPage, totalPage}} = this.props
    return currentPage < totalPage
  }
  _onErrorOrder = (name) => {
    this.setState({openErrorAlert: true, errorItemName: name})
    setTimeout(function () { this.setState({openErrorAlert: false, errorItemName: null}) }.bind(this), 1000)
  }
  _onClickSave = (values) => {
    this.setState({selectValue: null})
    this.props.onSubmit(values)
  }
  _onHide = (event) => {
    event.preventDefault()
    event.stopPropagation()
    const {dispatch} = this.props
    this.setState({selectValue: null, errorItemName: null})
    dispatch(onCancelModalAddItem())
  }
  _onKeywordChange = (value) => {
    const {dispatch, POForm, search: {namespace}} = this.props
    this.setState({selectValue: value})
    dispatch(change('addItemPurchase', 'items', []))
    dispatch(getItemsFromAPI({
      outlet_id: POForm.outlet,
      page: 1,
      per_page: 100,
      no_categories: true,
      keyword: value,
      namespace: namespace,
      first: false
    }))
  }
  _onSearchReachBottom = () => {
    const {items: {currentPage, total_pages: total, results}, dispatch, POForm, search: {namespace}} = this.props
    if (total > currentPage) {
      dispatch(getItemsFromAPI({
        outlet_id: POForm.outlet,
        page: currentPage + 1,
        per_page: 100,
        no_categories: true,
        keyword: this.state.selectValue,
        previousItems: results,
        namespace: namespace,
        first: false
      }))
    }
  }
  _onSelectedItem = (value) => {
    const {items, dispatch, POForm, search: {namespace}} = this.props
    let data = null
    items.results.forEach((i) => {
      if (i.id === value.value) {
        data = i
      }
    })
    if (data) {
      dispatch(setModalDataForm(namespace, data, POForm.itemPurchase))
      this.setState({selectValue: value.value})
      if (namespace !== NAMESPACE_INGREDIENTS) {
        this.setState({itemHasRecipe: data.is_recipe})
      }
    } else {
      this.setState({selectValue: null})
    }
  }
  _dismissError = () => {
    this.setState({openErrorAlert: false, errorItemName: null})
  }
  _normalizeOrder = (index) =>
    (value, previousValue, allValues) => {
      const {search: {namespace}} = this.props
      if (value === '') {
        return value
      } else {
        if (!isNaN(value)) {
          if (value) {
            if (parseInt(value) + parseInt(allValues.items[index].instock) <= 999999) {
              return value
            } else {
              this._onErrorOrder(namespace === NAMESPACE_INGREDIENTS
                ? allValues.items[index].item_name
                : !allValues.items[index].item_var_name ? allValues.items[index].item_name : allValues.items[index].item_var_name)
              return 999999 - parseInt(allValues.items[index].instock)
            }
          } else {
            return value
          }
        }
      }
    }
  _headerField = ({isOneItem}) => {
    const {search: {namespace}} = this.props
    return (<div className={`row ${styles.item}`}>
      {namespace !== NAMESPACE_INGREDIENTS && <div className={`col-md-3 text-center ${styles.itemHeader}`}>{isOneItem ? 'Item' : 'Variant'}</div>}
      {namespace === NAMESPACE_INGREDIENTS && <div className={`col-md-3 text-center ${styles.itemHeader}`}>Unit</div>}
      <div className={`col-md-2 text-center ${styles.itemHeader}`}>In Stock</div>
      <div className={`col-md-2 text-left ${styles.itemHeader}`}>Order</div>
      <div className={`col-md-2 text-left ${styles.itemHeader}`}>Unit Cost</div>
      <div className={`col-md-3 text-center ${styles.itemHeader}`}>Total</div>
    </div>)
  }
  _fieldItem = ({fields}) => {
    return (<div className={`mk-grouped-list-input`}>
      {fields.map(this._itemVariant)}
    </div>)
  }
  _itemVariant = (member, index, fields) => {
    const {search: {namespace}} = this.props
    let isItem = fields.get(index).is_item
    let {order, unitcost} = fields.get(index)
    let total = order * unitcost
    return (<div className={`mk-grouped-input`}>
      <div className={`form-group col-md-3 ${styles.name}`}>
        {isItem && <Field
          component={nameField}
          name={`${member}.item_name`}
          type='text'
        />}
        {!isItem && <Field
          component={nameField}
          name={`${member}.item_var_name`}
          type='text'
        />}
      </div>
      <Field
        component='input'
        name={`${member}.item_id`}
        type='hidden'
      />
      <Field
        component='input'
        name={`${member}.item_var_id`}
        type='hidden'
      />
      <div className={`form-group col-md-2 ${styles.middleTable}`}>
        <Field
          component={stockField}
          name={`${member}.instock`}
          type='text'
        />
      </div>
      <div className={`form-group col-md-1 ${styles.middleTable}`}>
        <Field
          component={SettingField}
          name={`${member}.order`}
          inputClassName={styles.itemDetail}
          type='text'
          placeholder='Order'
          normalize={this._normalizeOrder(index)}
          onChange={(event, value) => {
            if (namespace === NAMESPACE_INGREDIENTS) {
              total = parseFloat(value) * parseInt(unitcost)
            } else {
              total = parseInt(value) * parseInt(unitcost)
            }
            total = !isNaN(total) ? total : 0
            this.props.dispatch(change('addItemPurchase', `${member}.total`, rupiah(total)))
            return value
          }
          }
          positiveNumberOnly
          maxFractionDigits={namespace === NAMESPACE_INGREDIENTS ? 2 : 0}
        />
      </div>
      <div className={`form-group col-md-3 ${styles.middleTable} ${styles.unitCostContainer}`}>
        <div className={styles.rpfield}>Rp.</div>
        <Field
          component={SettingField}
          name={`${member}.unitcost`}
          type='text'
          placeholder='Unit Cost'
          inputClassName={styles.unitCost}
          normalize={normalizeNumber}
          onChange={(event, value) => {
            if (namespace === NAMESPACE_INGREDIENTS) {
              total = parseInt(value) * parseFloat(order)
            } else {
              total = parseInt(value) * parseInt(order)
            }
            total = !isNaN(total) ? total : 0
            this.props.dispatch(change('addItemPurchase', `${member}.total`, rupiah(total)))
            return value
          }
          }
          positiveNumberOnly
          maxFractionDigits={0}
        />
      </div>
      <div className={`${styles.total} form-group col-md-3`}>
        <Field
          component={totalField}
          name={`${member}.total`}
          type='text'
          disabled
        />
      </div>
    </div>)
  }

  _clickIngredient = () => {
    const {dispatch, search: {date: {startDate, endDate}}, keyword} = this.props
    const params = {
      page: 1,
      start: startDate.format('D/M/Y'),
      end: endDate.format('D/M/Y'),
      keyword
    }
    dispatch(askConfirmAction(onChangeNamespace('ingredients', params)))
  }
}

function mapStateToProps (state) {
  const {showModalItem, temporaryItem, alreadyAddedItem, addItems: {isLoading, items, firstItems}} = state.inventory.purchaseOrder
  return {
    showModalItem,
    isLoading,
    items,
    temporaryItem,
    alreadyAddedItem,
    firstItems,
    POForm: getFormValues('purchaseOrder')(state),
    addItemPurchase: getFormValues('addItemPurchase')(state),
    search: getFormValues('search')(state)
  }
}

function mapDispatchToProps (dispatch) {
  return {dispatch}
}

let mapForm = {
  form: 'addItemPurchase',
  touchOnBlur: true,
  touchOnChange: true,
  validate
}

export default reduxForm(mapForm)(connect(mapStateToProps, mapDispatchToProps)(ModalAddItem))



// WEBPACK FOOTER //
// ./app/pages/Inventory/PurchaseOrder/ModalAddItem/ModalAddItem.js